import axios from 'axios';

// axios instance with authorization header
export const axiosAuth = axios.create({});

//axios instance without header
export const axiosNoAuth = axios.create({});
